import * as React from "react";
import { IGameTop } from "../../../api_types";
import { StyledTable } from "../../../styles/Racelive";

interface IProps {
  data: IGameTop;
}
const TableSkeleon = ({ data }: IProps) => {
  return (
    <StyledTable>
      <thead>
        <tr>
          <td>司放地点</td>
          <td>司放时间</td>
          <td>经度</td>
          <td>纬度</td>
          <td>天气</td>
          <td>参考空距(M)</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{data.PlaceName === "" ? "---" : data.PlaceName}</td>
          <td>
            {data.StringClockStart === "" ? "---" : data.StringClockStart}
          </td>
          <td>{data.StringE_HMS === "" ? "---" : data.StringE_HMS}</td>
          <td>{data.StringN_HMS === "" ? "---" : data.StringN_HMS}</td>
          <td>{data.PlaceWeather === "" ? "---" : data.PlaceWeather}</td>
          <td>{data.PlaceDistance === "" ? "---" : data.PlaceDistance}</td>
        </tr>
      </tbody>
    </StyledTable>
  );
};

export default TableSkeleon;
